var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wheel-home-history" }, [
    _c("div", { staticClass: "rounds-stats" }, [
      _c("div", { staticClass: "rounds-stats__title" }, [
        _vm._v("最近 100 轮"),
      ]),
      _vm.colorStats
        ? _c("div", { staticClass: "rounds-stats__colors" }, [
            _c(
              "div",
              { staticClass: "rounds-stats__color rounds-stats__color_2x" },
              [
                _vm._v(
                  " " + _vm._s(_vm.colorStats[_vm.Multiplier.X2] || 0) + " "
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "rounds-stats__color rounds-stats__color_3x" },
              [
                _vm._v(
                  " " + _vm._s(_vm.colorStats[_vm.Multiplier.X3] || 0) + " "
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "rounds-stats__color rounds-stats__color_5x" },
              [
                _vm._v(
                  " " + _vm._s(_vm.colorStats[_vm.Multiplier.X4] || 0) + " "
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "rounds-stats__color rounds-stats__color_20x" },
              [
                _vm._v(
                  " " + _vm._s(_vm.colorStats[_vm.Multiplier.X35] || 0) + " "
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "history" }, [
      !_vm.streamerMode
        ? _c("div", { staticClass: "history__title" }, [_vm._v("历史游戏")])
        : _c("div", { staticClass: "history__title" }, [_vm._v("历史轮次")]),
      _c(
        "div",
        { staticClass: "history__wrapper" },
        [
          _c(
            "div",
            { staticClass: "history__games" },
            [_c("HomeHistoryGames", { attrs: { games: _vm.history } })],
            1
          ),
          _c(
            "router-link",
            {
              staticClass: "history__action btn btn_hiw",
              attrs: { to: { name: _vm.wheelHistoryRouteName } },
            },
            [
              _c("span", { staticClass: "icon icon_history-alt" }),
              _c("span", { staticClass: "btn__text" }, [_vm._v("历史记录")]),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }